import {client} from './services/client'

export const intramwallets = {
    namespaced: true,
    state: {
        intramwallets: undefined,
        incomes:undefined,
        wallet:undefined

    },
    mutations: {
        SET_IW(state, intramwallets) {
            state.intramwallets = intramwallets
        },
        SET_WALLET_INCOMES(state,incomes){
            state.incomes = incomes;
        },
        SET_WALLET(state,wallet){
            state.wallet = wallet;
        }
    },
    actions: {
        getIntramwallets({commit}) {
            return new Promise((resolve, reject) => {
                client({
                    method: 'get',
                    url: '/intramwallets/get',
                })
                    .then((response) => {
                        let intramwallets = response.data.intramwallets;
                        commit('SET_IW', intramwallets);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })

        },
        getWalletDetails({commit},id) {
            return new Promise((resolve, reject) => {
                client({
                    method: 'get',
                    url: '/intramwallets/details/'+id,
                })
                    .then((response) => {
                        commit('SET_WALLET_INCOMES', response.data.incomes);
                        commit('SET_WALLET', response.data.wallet);
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })

        },

    },
    getters: {
        getintramwallets: state => {
            return state.intramwallets
        },


    }
};
